import { useTheme } from '@mui/material';
import { useTenant } from '../../../contexts/TenantContext';
import { filledButtonSx } from '../../../components/CustomButton';

/**
 * How the dashboard paints a filled action: in the tenant's primary colour, not its button colour.
 * For most tenants the two are one colour, and nothing differs from the guest pages. herevr's
 * buttons are yellow, made for its dark site; on the admin's light pages its primary blue is used
 * instead, the colour the dashboard's outlined buttons and switches wear already.
 *
 * The ink is the tenant's own button ink where the two colours are one, and otherwise the one
 * that reads on the primary colour.
 */
const useAdminButton = () => {
  const theme = useTheme();
  const { displayConfig } = useTenant();
  const color = displayConfig?.primaryColor;
  const textColor = color === displayConfig?.buttonColor
    ? displayConfig?.buttonTextColor
    : theme.palette.primary.contrastText;

  return { color, textColor, filledSx: filledButtonSx(displayConfig, color, textColor) };
};

export default useAdminButton;
